<template>
  <div class="order-page">
    <div class="page-container">
      <!-- 面包屑 -->
      <nav class="breadcrumb">
        <a class="bc-link" @click.prevent="goHome">首页</a>
        <span class="bc-sep">/</span>
        <span class="bc-current">我的订单</span>
      </nav>

      <!-- Hero -->
      <div class="hero-row">
        <div class="hero-left">
          <!-- <p class="hero-brand">关盈堂 · 服务记录</p> -->
          <!-- <h1 class="hero-title">每一份订单，都有迹可循</h1> -->
          <!-- <p class="hero-subtitle">查看开方与配送记录，让健康服务进度一目了然。</p> -->
        </div>
        <button class="hero-back" type="button" @click="goHome">
          <span>返回我的服务</span>
          <span class="hero-back-arrow" aria-hidden="true">→</span>
        </button>
      </div>

      <!-- 提示条 -->
      <!-- <div class="notice-bar">
        <span class="notice-icon" aria-hidden="true">!</span>
        <p class="notice-text">订单金额、支付结果与配送进度均以服务端记录为准；如与实际不符，请联系管理员核对。</p>
      </div> -->

      <!-- 双栏：左订单中心 / 右订单列表 -->
      <div class="layout">
        <aside class="side-col">
          <div class="side-card">
            <h2 class="side-title">我的订单</h2>

            <nav class="side-tabs">
              <button type="button" class="side-tab" :class="{ active: orderType == '0' }"
                @click="switchOrderType('0')">
                <span class="st-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8"
                    stroke-linecap="round" stroke-linejoin="round">
                    <rect x="4" y="3" width="16" height="18" rx="2" />
                    <path d="M8 8h8M8 12h8M8 16h5" />
                  </svg>
                </span>
                <span class="st-body">
                  <span class="st-name">开方订单</span>
                  <span class="st-desc">药方与支付状态记录</span>
                </span>
                <span class="st-arrow" aria-hidden="true">→</span>
              </button>

              <!-- <button type="button" class="side-tab" :class="{ active: orderType == '1' }"
                @click="switchOrderType('1')">
                <span class="st-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z" />
                    <circle cx="7" cy="18" r="1.6" />
                    <circle cx="17" cy="18" r="1.6" />
                  </svg>
                </span>
                <span class="st-body">
                  <span class="st-name">配送订单</span>
                  <span class="st-desc">药品配送物流记录</span>
                </span>
                <span class="st-arrow" aria-hidden="true">→</span>
              </button> -->
            </nav>

            <div class="side-note">
              <p class="sn-title">服务安心，记录清晰</p>
            </div>
          </div>

          <button class="side-cta" type="button" @click="goPrescription">
            <span>开启中药组方</span>
            <span class="side-cta-arrow" aria-hidden="true">→</span>
          </button>
        </aside>

        <section class="main-col">

          <!-- 订单列表卡 -->
          <div class="panel-card">
            <div class="panel-head">
              <h2 class="panel-title">{{ panelTitle }}</h2>
            </div>
            <!-- 筛选 -->
            <div class="filter-row">
              <div class="filter-field">
                <label class="filter-label">订单月份</label>
                <el-date-picker class="filter-month" prefix-icon="none" v-model="orderMonth"
                  @change="datePickerChange" value-format="yyyy-MM" align="center" type="month" placeholder="年-月" />
              </div>
              <div class="filter-field filter-grow">
                <label class="filter-label">患者姓名或手机号</label>
                <el-input class="filter-input" v-model="searchText" placeholder="输入姓名或手机号码"
                  @keyup.enter.native="search" />
              </div>
              <button class="btn-search" type="button" @click="search">搜索</button>
              <button class="btn-reset" type="button" @click="resetFilter">重置</button>
            </div>

            <!-- 状态筛选 -->
            <div class="status-pills">
              <button v-for="s in statusOptions" :key="s.value" type="button" class="pill"
                :class="{ active: currentStatus == s.value }" @click="onStatusClick(s.value)">
                <span>{{ s.label }}</span>
              </button>
            </div>

            <!-- 订单卡片列表 -->
            <div class="order-list" v-if="listRows.length > 0">
              <div class="order-item" v-for="row in listRows" :key="row.key" @click="onRowClick(row.raw)">
                <div class="oi-head">
                  <span class="oi-no"><span class="oi-no-label">订单编号 ·</span>{{ row.orderNo }}</span>
                  <span class="oi-status" v-if="row.typeText">{{ row.typeText }}</span>
                </div>
                <div class="oi-body">
                  <span class="oi-avatar">{{ avatarText(row.name) }}</span>
                  <div class="oi-main">
                    <span class="oi-name">{{ row.name }}</span>
                    <span class="oi-sub">
                      <!-- <span class="oi-type" v-if="row.typeText">{{ row.typeText }}</span> -->
                      <span class="oi-phone">手机号：{{ row.phone }}</span>
                    </span>
                  </div>
                  <div class="oi-meta">
                    <div class="oi-meta-cell">
                      <span class="oi-meta-label">下单时间</span>
                      <span class="oi-meta-value">{{ row.time }}</span>
                    </div>
                  </div>
                  <span class="oi-detail">查看详情 <em aria-hidden="true">→</em></span>
                </div>
              </div>
            </div>

            <!-- 空状态 -->
            <div class="order-empty" v-else>
              <p>{{ emptyText }}</p>
            </div>

            <!-- 分页 -->
            <div class="order-pager">
              <span class="pager-total">共 {{ currentRawTotal }} 笔 · 第 {{ pagerPage }} / {{ currentPageCount }} 页</span>
              <el-pagination v-if="pagerVisible" class="pagination" background layout="prev, pager, next"
                :current-page="pagerPage" @current-change="onPageChange" :total="pagerTotal" />
            </div>
          </div>
        </section>
      </div>
    </div>

    <el-dialog title="微信支付" :visible.sync="qrcodeVisble" width="360px" :close-on-click-modal="dialogClosable">
      <div class="dialog-wrapper">
        <div id="qrcode"></div>
        <span class="qrcode-dialog-text">二维码过期了？<b @click="qrcodeRefresh">立即刷新</b></span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
let un_pay_status = "0"; //未支付
let payed_status = "1"; //已支付
let order_avaliable_status = "2"; //订单生效
let prescripting_status = "3"; //配药中
let expressing_status = "4"; //配送中
let express_complete_status = "5"; //配送完成
import WJTRadio from "@/components/widgets/wjt-radio.vue";
import QRCode from "qrcodejs2";
export default {
  name: "orderList",
  components: {
    WJTRadio,
  },
  data() {
    return {
      currentOrderList: [],
      currentFulOrderList: [],
      activeName1: "-1",
      activeName2: "-1",
      orderType: "0", //0:开方  1：配送
      orderMonth: "",
      tableBorder: false,
      tableFulBorder: false,
      tableDraftBorder: false,
      currentPageNo: 1,
      currentFulPageNo: 1,
      currentDraftPageNo: 1,
      pageSize: 5,
      pageFulSize: 5,
      pageDraftSize: 5,
      totalPage: 1,
      totalFulPage: 1,
      totalDraftPage: 1,
      searchText: "",
      emptyText: "您还没有订单",
      editable: false,
      confirmLoading: false,
      payType: {
        key: "",
        value: "微信支付",
        options: ["公共账户", "微信支付"],
      },
      qrcodeVisble: false,
      outTradeNo: "",
      currentIndex: 0,
      dialogClosable: false,
      showPopver: false,
      isSearch: false,
      currentDraftList: [],
      // 新版式：统计计数（列表总条数 + 待付款/已付款）
      orderRawTotal: 0,
      fulRawTotal: 0,
      draftRawTotal: 0,
      // 初始化中：created 回填持久化缓存时会连续改 orderType / searchText，
      // 期间锁住 watch，避免重复请求（加载统一由 created 末尾发起）
      syncing: true,
    };
  },
  created() {
    console.log("order created");
    var data = this.$store.getters.getOrderData;
    console.log(data);
    if (!this.utils.isEmptyObject(data)) {
      // 旧缓存里 activeName1 存的是支付状态(0/1/2)，现已改为处方类型，非法值回退为「全部」
      var typeCodes = ["-1", "D", "A", "M", "C", "P", "T", "S"];
      this.activeName1 = typeCodes.indexOf(data.activeName1) > -1 ? data.activeName1 : "-1";
      this.activeName2 = data.activeName2;
      this.orderType = data.orderType;
      this.orderMonth = data.orderMonth;
      this.currentPageNo = data.currentPageNo;
      this.currentFulPageNo = data.currentFulPageNo;
      this.currentDraftPageNo = data.currentDraftPageNo;
      this.pageSize = data.pageSize;
      this.pageFulSize = data.pageFulSize;
      this.pageDraftSize = data.pageDraftSize;
      this.totalPage = data.totalPage;
      this.totalFulPage = data.totalFulPage;
      this.totalDraftPage = data.totalDraftPage;
      this.searchText = data.searchText;
      this.currentIndex = data.currentIndex;
      this.isSearch = data.isSearch;
    }
    // 每页固定 5 条
    this.pageSize = 5;
    this.pageFulSize = 5;
    this.pageDraftSize = 5;
    var userInfo = this.$store.getters.getUserInfo;
    console.log(userInfo);
    if (!this.utils.isEmptyObject(userInfo)) {
      if (userInfo.doctor && userInfo.doctor.hospitalId == 101) {
        this.showPopver = false;
      } else {
        this.showPopver = true;
      }
    }
    if (this.orderType == "0") {
      this.getOrderList();
    } else if (this.activeName2 == "100") {
      this.getDraftList();
    } else {
      this.getFulOrderList();
    }
    // 等 watch 队列执行完再解锁
    this.$nextTick(() => {
      this.syncing = false;
    });
  },
  computed: {
    // 当前选中的筛选项（开方=处方类型 / 配送=配送状态，各自维护）
    currentStatus() {
      return this.orderType == "0" ? this.activeName1 : this.activeName2;
    },
    // 开方订单：按「处方类型」字典筛选（health/v1/prescription/order 的 type 参数）
    // 配送订单：仍按配送状态筛选
    statusOptions() {
      if (this.orderType == "0") {
        return [
          { label: "全部", value: "-1" },
          { label: "健康指引", value: "D" },
          // { label: "针灸", value: "A" },
          // { label: "按摩", value: "M" },
          { label: "草本压片", value: "C" },
          { label: "中药AI组方", value: "P" },
          { label: "本草茶饮", value: "T" },
          // { label: "自拟组方", value: "S" },
        ];
      }
      return [
        { label: "全部", value: "-1" },
        { label: "草稿", value: "100" },
        { label: "待付款", value: "0" },
        { label: "待收货", value: "1" },
        { label: "已完成", value: "2" },
        { label: "已取消", value: "3" },
      ];
    },
    panelTitle() {
      if (this.orderType == "0") return "开方订单";
      // return this.activeName2 == "100" ? "配送草稿" : "配送订单";
      return this.activeName2 == "100" ? "配送草稿" : "配送订单";
    },
    // 当前列表的总条数
    currentRawTotal() {
      if (this.orderType == "0") return this.orderRawTotal;
      return this.activeName2 == "100" ? this.draftRawTotal : this.fulRawTotal;
    },
    currentPageCount() {
      var raw = this.currentRawTotal;
      return raw > 0 ? Math.ceil(raw / this.pageSize) : 1;
    },
    // 分页（沿用原有 total / currentPage 语义，保证翻页行为一致）
    pagerPage() {
      if (this.orderType == "0") return this.currentPageNo;
      return this.activeName2 == "100" ? this.currentDraftPageNo : this.currentFulPageNo;
    },
    pagerTotal() {
      if (this.orderType == "0") return this.totalPage;
      return this.activeName2 == "100" ? this.totalDraftPage : this.totalFulPage;
    },
    pagerVisible() {
      if (this.orderType == "0") return this.totalPage > 10;
      return this.activeName2 == "100" ? this.totalDraftPage > 10 : this.totalFulPage > 10;
    },
    // 归一化后的订单卡片数据
    listRows() {
      var rows = [];
      var i;
      if (this.orderType == "0") {
        var list1 = this.currentOrderList || [];
        for (i = 0; i < list1.length; i++) {
          var r = list1[i];
          rows.push({
            raw: r,
            key: "o-" + (r.visitRecordId || i),
            orderNo: r.visitRecordId || "—",
            statusText: r.statusDesc || "",
            name: r.patientName || "—",
            typeText: r.typeText || "",
            phone: r.patientPhoneNo || "未填写",
            time: r.createTimeString || "",
          });
        }
        return rows;
      }
      if (this.activeName2 == "100") {
        var list2 = this.currentDraftList || [];
        for (i = 0; i < list2.length; i++) {
          var d = list2[i];
          rows.push({
            raw: d,
            key: "d-" + (d.visitRecordId || i),
            orderNo: d.visitRecordId || "—",
            statusText: "草稿",
            name: d.recipientName || "—",
            typeText: "配送草稿",
            phone: d.recipientPhone || "未填写",
            time: d.createTime || "",
          });
        }
        return rows;
      }
      var list3 = this.currentFulOrderList || [];
      for (i = 0; i < list3.length; i++) {
        var f = list3[i];
        rows.push({
          raw: f,
          key: "f-" + (f.deliveryOrderId || i),
          orderNo: f.deliveryOrderId || "—",
          statusText: f.statusText || "",
          name: f.patientName || "—",
          typeText: f.typeText || "",
          phone: f.patientPhoneNo || "未填写",
          time: f.createTime || "",
        });
      }
      return rows;
    },
  },
  methods: {
    search() {
      this.isSearch = true;
      if (this.orderType == "0") {
        this.currentPageNo = 1;
        this.getOrderList();
      } else {
        this.currentFulPageNo = 1;
        this.getFulOrderList();
      }
    },
    /* ===== 新版式：UI 交互（不改变原有业务逻辑） ===== */
    goHome() {
      this.$router.push("/");
    },
    goPrescription() {
      this.$router.push({
        path: "/addPrescriptionContact",
        query: { serviceIndex: 6 },
      });
    },
    switchOrderType(type) {
      if (this.orderType == type) return;
      this.orderType = type;
    },
    onStatusClick(value) {
      if (this.orderType == "0") {
        this.activeName1 = value;
        this.handleClick();
      } else {
        this.activeName2 = value;
        this.handleFulClick();
      }
    },
    onRowClick(row) {
      if (this.orderType == "0") {
        this.tableClick(row);
      } else if (this.activeName2 == "100") {
        this.tableDraftClick(row);
      } else {
        this.tableFulClick(row);
      }
    },
    onPageChange(page) {
      if (this.orderType == "0") {
        this.pageChange(page);
      } else if (this.activeName2 == "100") {
        this.pageDraftChange(page);
      } else {
        this.pageFulChange(page);
      }
    },
    resetFilter() {
      this.orderMonth = "";
      this.searchText = "";
      this.isSearch = false;
      this.currentPageNo = 1;
      this.currentFulPageNo = 1;
      this.currentDraftPageNo = 1;
      if (this.orderType == "0") {
        this.getOrderList();
      } else if (this.activeName2 == "100") {
        this.getDraftList();
      } else {
        this.getFulOrderList();
      }
    },
    avatarText(name) {
      var n = name ? String(name) : "";
      return n ? n.charAt(0) : "订";
    },
    getOrderList() {
      var params = {
        pageNum: this.currentPageNo,
        pageSize: this.pageSize,
        keyWord: this.isSearch ? this.searchText : "",
        createTimeString: this.orderMonth,
      };
      // 处方类型筛选（字典值：D/A/M/C/P/T/S），选「全部」时不传
      if (this.activeName1 != "-1") {
        params.type = this.activeName1;
      }

      this.wjtHttp.get(
        this,
        "/api/health/v1/prescription/order",
        params,
        false,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            var orderList = data.rows;
            this.orderRawTotal = data.total || 0;
            this.currentOrderList = orderList;
            if (!this.utils.isEmptyStr(orderList)) {
              this.totalPage = Math.ceil(data.total / this.pageSize) * 10;
              for (var i = 0; i < orderList.length; i++) {
                // orderList[i].typeText = [];
                // orderList[i].prescriptionType == "S"
                //   ? "自拟组方"
                //   : "智能开方";
                // if (orderList[i].prescriptionType == "R") {
                //   orderList[i].typeText = "私人订制茶";
                // }if (orderList[i].prescriptionType == "Z") {
                //   orderList[i].typeText = "公共自拟方";
                // } else if (orderList[i].prescriptionType == "S") {
                //   orderList[i].typeText = "自拟组方";
                // } else {
                //   orderList[i].typeText = "智能开方";
                // }
                // orderList[i].typeText=orderList[i].prescriptionTypeString
                if (this.showPopver) {
                  orderList[i].payType = {
                    key: "",
                    value: "微信支付",
                    options: ["公共账户", "微信支付"],
                  };
                } else {
                  orderList[i].payType = {
                    key: "",
                    value: "微信支付",
                    options: ["微信支付"],
                  };
                }
              }
            } else if (this.currentPageNo == 1) {
              this.emptyText = "您当月没有订单";
              this.totalPage = 1;
            }
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0
                  ? data.msg
                  : "订单服务异常，请联系管理员",
              type: "error",
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getFulOrderList() {
      var status = "";
      if (this.activeName2 == "0") {
        status = un_pay_status;
      } else if (this.activeName2 == "1") {
        status =
          payed_status +
          "_" +
          order_avaliable_status +
          "_" +
          prescripting_status +
          "_" +
          expressing_status;
      } else if (this.activeName2 == "2") {
        status = express_complete_status;
      } else if (this.activeName2 == "3") {
        status = "-1_-2_-3_-4_-5_-6";
      } else if (this.activeName2 == "-1") {
        status = "0_1_2_3_4_5_-1_-2_-3_-4_-5_-6";
      }
      this.wjtHttp.get(
        this,
        "/api/delivery/order/list",
        {
          pageNum: this.currentFulPageNo,
          pageSize: this.pageFulSize,
          status: status,
          patientName: this.isSearch ? this.searchText : "",
          queryMonth: this.orderMonth,
        },
        true,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            var orderList = data.rows;
            this.fulRawTotal = data.total || 0;
            this.currentFulOrderList = orderList;
            if (!this.utils.isEmptyStr(orderList)) {
              this.totalFulPage = Math.ceil(data.total / this.pageFulSize) * 10;
            } else if (this.currentFulPageNo == 1) {
              this.emptyText = "您当月没有订单";
              this.totalFulPage = 1;
            }
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0
                  ? data.msg
                  : "订单服务异常，请联系管理员",
              type: "error",
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getDraftList() {
      this.wjtHttp.get(
        this,
        "/api/delivery/order/draft/list",
        {
          pageNum: this.currentDraftPageNo,
          pageSize: this.pageDraftSize,
          patientPhoneNo: this.isSearch ? this.searchText : "",
          queryMonth: this.orderMonth,
        },
        true,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            var draftList = data.rows;
            this.draftRawTotal = data.total || 0;
            this.currentDraftList = draftList;
            if (!this.utils.isEmptyStr(draftList)) {
              this.totalDraftPage = Math.ceil(data.total / this.pageDraftSize) * 10;
            } else if (this.currentDraftPageNo == 1) {
              this.emptyText = "您当月没有草稿";
              this.totalDraftPage = 1;
            }
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0
                  ? data.msg
                  : "获取草稿异常，请联系管理员",
              type: "error",
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    handleClick() {
      this.currentPageNo = 1;
      this.searchText = "";
      this.isSearch = false;
      this.getOrderList();
    },
    handleFulClick() {
      this.currentFulPageNo = 1;
      this.searchText = "";
      this.isSearch = false;
      if (this.activeName2 == "100") {
        this.getDraftList();
      } else {
        this.getFulOrderList();
      }
    },
    pageChange(pageNo) {
      this.currentPageNo = pageNo;
      this.getOrderList();
    },
    pageFulChange(pageNo) {
      this.currentFulPageNo = pageNo;
      this.getFulOrderList();
    },
    pageDraftChange(pageNo) {
      this.currentDraftPageNo = pageNo;
      this.getDraftList();
    },
    isUserTypeByValue(roles, val) {
      for (var i = 0; i < roles.length; i++) {
        var value = roles[i];
        if (value == val) {
          return true;
        }
      }
      return false;
    },
    // 健康指引(D)/草本压片(C)/本草茶饮(T) 订单详情 → serviceResult（订单详情模式）
    // 改为按订单号请求：/health/v1/prescription/order/text/{visitRecordId}
    openServiceResult(row) {
      this.$router.push({
        path: "/serviceResult",
        query: {
          visitRecordId: row.visitRecordId,
          type: row.type || row.prescriptionType || "",
        },
      });
    },
    tableClick(row, column, event) {
      // 处方类型：优先取字典码 type，兼容旧字段 prescriptionType，并对 typeText 兜底
      var typeCode = String(row.type || row.prescriptionType || "").toUpperCase();
      var typeText = String(row.typeText || "");
      // 健康指引(D) / 本草压片(C) / 本草茶饮(T) → 订单详情页（按订单号请求文本详情）
      var isTextDetailType =
        typeCode == "D" || typeCode == "C" || typeCode == "T" ||
        typeText.indexOf("健康指引") > -1 || typeText.indexOf("压片") > -1 || typeText.indexOf("茶饮") > -1;
      if (isTextDetailType) {
        this.openServiceResult(row);
        return;
      }

      // var userInfo = this.$store.getters.getUserInfo;
      // var roles = userInfo.roles;
      // if (this.isUserTypeByValue(roles, "common_doctor")) {
      //   this.$router.push({
      //       path: "/commonHandmadePrescriptionDetails",
      //       query: {
      //         visitRecordId: row.visitRecordId,
      //         patientId: row.patientId,
      //         prescriptionType: row.prescriptionType,
      //       },
      //     });
      //     return
      // }

      if (row.status == "1") {
        if (row.prescriptionType == "G") {
          this.$router.push({
            path: "/GeneralPrescription",
            query: {
              visitRecordId: row.visitRecordId,
              patientId: row.patientId,
              prescriptionType: row.prescriptionType,
            },
          });
        } else if (row.prescriptionType == "R") {
          this.$router.push({
            path: "/CUSTOMIZEDPrescription",
            query: {
              visitRecordId: row.visitRecordId,
              patientId: row.patientId,
              prescriptionType: row.prescriptionType,
            },
          });
        } else if (row.prescriptionType == "Z") {
          this.$router.push({
            path: "/commonHandmadePrescriptionDetails",
            query: {
              visitRecordId: row.visitRecordId,
              patientId: row.patientId,
              prescriptionType: row.prescriptionType,
            },
          });
        } else if (row.prescriptionType == "B") {
          sessionStorage.setItem("visitRecordId", row.visitRecordId);
          this.$router.push({
            path: "/chaoweiPrescription",
            query: {
              visitRecordId: row.visitRecordId,
              patientId: row.patientId,
              prescriptionType: row.prescriptionType,
            },
          });
        } else {
          this.$router.push({
            path: "/prescription",
            query: {
              visitRecordId: row.visitRecordId,
              patientId: row.patientId,
              prescriptionType: row.prescriptionType,
            },
          });
        }
      } else {
        // 未支付订单原来点上去毫无反应，这里给个提示，避免误以为卡片失效
        this.$message({ message: "该订单尚未完成支付，暂无法查看详情", type: "warning" });
      }
    },
    tableFulClick(row, column, event) {
      if (row.form == "R") {
        this.$router.push({
          path: "/CUSTOMIZEDfulfillmentOrder",
          query: {
            orderId: row.deliveryOrderId,
          },
        });
      } else {
        this.$router.push({
          path: "/fulfillmentOrder",
          query: {
            orderId: row.deliveryOrderId,
          },
        });
      }
    },
    tableDraftClick(row, column, event) {
      var userInfo = this.$store.getters.getUserInfo;
      var roles = userInfo && userInfo.roles ? userInfo.roles : [];
      var isAgentDemo = false;
      for (var i = 0; i < roles.length; i++) {
        if (roles[i] == "level1" || roles[i] == "level2") {
          isAgentDemo = true;
          break;
        }
      }
      if (isAgentDemo) {
        this.$message.warning("当前为演示账号，配送下单功能暂未开放");
        return;
      }
      sessionStorage.setItem(
        "prescription",
        JSON.stringify({
          endDate: row.endDate,
          startDate: row.startDate,
          type: row.type,
          visitRecordId: row.visitRecordId,
        })
      );
      this.$router.push({
        path: "/fulfillmentConfirm",
        query: {
          mode: 1,
        },
      });
    },
    datePickerChange(value) {
      this.orderMonth = value;
      this.currentPageNo = 1;
      this.isSearch = false;
      if (this.orderType == "0") {
        this.getOrderList();
      } else {
        this.getFulOrderList();
      }
    },
    pay(index) {
      if (this.mInterval) {
        clearInterval(this.mInterval);
      }
      this.currentIndex = index;
      var order = this.currentOrderList[index];
      var params = {
        productId: order.visitRecordId,
        orderType: 1,
        tradeType: "NATIVE",
        payChannel: order.payType.value == "微信支付" ? "1" : "3",
      };
      this.wjtHttp.post(
        this,
        "/api/api/pay/0.1/unifiedOrder",
        params,
        false,
        (res) => {
          var data = res.data;
          this.payLoading = false;
          if (data.code == 200) {
            if (
              data.data.payChannel == 1 &&
              !this.utils.isEmptyStr(data.data.qrcode)
            ) {
              this.qrcodeVisble = true;
              this.outTradeNo = data.data.outTradeNo;
              this.$nextTick(() => {
                if (this.mQrCode != undefined && this.mQrCode != null) {
                  this.mQrCode.clear();
                  this.mQrCode.makeCode(data.data.qrcode);
                } else {
                  this.mQrCode = new QRCode("qrcode", {
                    text: data.data.qrcode,
                    width: 256,
                    height: 256,
                    colorDark: "#000000",
                    colorLight: "#ffffff",
                    correctLevel: QRCode.CorrectLevel.H,
                  });
                }
                this.getPayStatus();
              });
            } else {
              this.$message({
                message: "提交成功",
                type: "success",
              });
              this.getOrderList();
            }
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0
                  ? data.msg
                  : "支付异常，请联系管理员",
              type: "error",
            });
          }
        },
        (err) => {
          console.log(err);
          this.payLoading = false;
        }
      );
    },
    qrcodeRefresh() {
      this.pay(this.currentIndex);
    },
    getPayStatus() {
      if (this.mInterval != undefined && this.mInterval != null) {
        clearInterval(this.mInterval);
      }
      this.mInterval = setInterval(() => {
        var params = {
          outTradeNo: this.outTradeNo,
        };
        this.wjtHttp.post(
          this,
          "/api/api/pay/0.1/query/place/result",
          params,
          false,
          (res) => {
            var data = res.data;
            if (data.code == 200) {
              if (data.data == 1103) {
                this.$message({
                  message: "提交成功",
                  type: "success",
                });
                this.qrcodeVisble = false;
                this.getOrderList();
                clearInterval(this.mInterval);
              }
            }
          },
          (err) => {
            console.log(err);
          }
        );
      }, 3000);
    },
  },
  beforeDestroy() {
    if (this.mInterval) {
      clearInterval(this.mInterval);
    }
    console.log("order beforeDestroy");
    this.$store.commit("updateOrderData", {
      activeName1: this.activeName1,
      activeName2: this.activeName2,
      orderType: this.orderType, //0:开方  1：配送
      orderMonth: this.orderMonth,
      currentPageNo: this.currentPageNo,
      currentFulPageNo: this.currentFulPageNo,
      currentDraftPageNo: this.currentDraftPageNo,
      pageSize: this.pageSize,
      pageFulSize: this.pageFulSize,
      pageDraftSize: this.pageDraftSize,
      totalPage: this.totalPage,
      totalFulPage: this.totalFulPage,
      totalDraftPage: this.totalDraftPage,
      searchText: this.searchText,
      currentIndex: this.currentIndex,
      isSearch: this.isSearch,
    });
  },
  beforeRouteLeave(to, from, next) {
    console.log(to);
    if (to.name != "Prescription" && to.name != "fulfillmentOrder") {
      this.$store.commit("updateOrderData", {});
    }
    next();
  },
  watch: {
    searchText: function (val) {
      if (this.syncing) return;
      if (this.utils.isEmptyStr(val)) {
        this.currentPageNo = 1;
        this.isSearch = false;
        if (this.orderType == "0") {
          this.getOrderList();
        } else if (this.activeName2 == "100") {
          this.getDraftList();
        } else {
          this.getFulOrderList();
        }
      }
    },
    orderType: function (val) {
      if (this.syncing) return;
      this.isSearch = false;
      this.searchText = "";
      if (val == "0") {
        this.getOrderList();
      } else if (this.activeName2 == "100") {
        this.getDraftList();
      } else {
        this.getFulOrderList();
      }
    },
  },
};
</script>

<style scoped>
/* ============================================================
   OrderPage — 我的订单（青绿主题 / 参考设计图）
   ============================================================ */
.order-page {
  min-height: 60vh;
  background: #f5f7f2;
  color: #304744;
  padding-bottom: 20px;
}

.page-container {
  max-width: 1220px;
  margin: 0 auto;
  padding: 32px 24px 40px;
}

/* ========== 面包屑 ========== */
.breadcrumb {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  margin-bottom: 18px;
}

.bc-link {
  color: #527f77;
  cursor: pointer;
}

.bc-link:hover {
  color: #009798;
}

.bc-sep {
  color: #b6c6c1;
}

.bc-current {
  color: #304744;
  font-weight: 600;
}

/* ========== Hero ========== */
.hero-row {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 22px;
}

.hero-brand {
  margin: 0 0 14px;
  font-size: 16px;
  font-weight: 600;
  color: #009798;
  letter-spacing: 1px;
}

.hero-title {
  margin: 0 0 12px;
  font-size: 40px;
  font-weight: 700;
  color: #304744;
  letter-spacing: 1px;
  line-height: 1.2;
}

.hero-subtitle {
  margin: 0;
  font-size: 17px;
  color: #527f77;
}

.hero-back {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 46px;
  padding: 0 22px;
  border: 1px solid #cfdcd8;
  border-radius: 12px;
  background: #fff;
  color: #304744;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.hero-back:hover {
  border-color: #009798;
  color: #009798;
}

.hero-back-arrow {
  color: #009798;
  font-weight: 700;
}

/* ========== 提示条 ========== */
.notice-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 22px;
  margin-bottom: 26px;
  border: 1px solid #f2e4c4;
  border-radius: 14px;
  background: #fdf7e9;
}

.notice-icon {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1.5px solid #c9a24a;
  color: #c9a24a;
  font-size: 16px;
  font-weight: 700;
}

.notice-text {
  margin: 0;
  font-size: 16px;
  line-height: 1.6;
  color: #8a6d3b;
}

/* ========== 双栏布局 ========== */
.layout {
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 28px;
  align-items: start;
}

.side-col {
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: sticky;
  top: 16px;
}

/* ========== 左侧订单中心 ========== */
.side-card {
  background: #fff;
  border: 1px solid #e9efec;
  border-radius: 20px;
  padding: 24px 22px;
  box-shadow: 0 10px 30px rgba(23, 61, 59, 0.05);
}

.side-eyebrow {
  margin: 0 0 10px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 2px;
  color: #a9bcb6;
}

.side-title {
  margin: 0 0 18px;
  font-size: 28px;
  font-weight: 700;
  color: #304744;
}

.side-tabs {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 18px;
  margin-bottom: 18px;
  border-bottom: 1px solid #eef2f0;
}

.side-tab {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 14px 14px;
  border: 1px solid transparent;
  border-radius: 14px;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  transition: all 0.2s ease;
}

.side-tab:hover {
  background: #eef6f4;
}

.side-tab.active {
  background: #e6f4f1;
  border-color: #cfe5e2;
}

.st-icon {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: #f1f7f5;
  color: #7f9994;
}

.side-tab.active .st-icon {
  background: #d9efeb;
  color: #009798;
}

.st-body {
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex: 1;
  min-width: 0;
}

.st-name {
  font-size: 17px;
  font-weight: 600;
  color: #304744;
}

.st-desc {
  font-size: 16px;
  color: #9aa8a3;
}

.st-arrow {
  flex-shrink: 0;
  color: #b6c6c1;
  font-size: 16px;
}

.side-tab.active .st-arrow {
  color: #009798;
}

.side-note {
  padding-top: 2px;
}

.sn-title {
  margin: 0 0 8px;
  font-size: 17px;
  font-weight: 600;
  color: #304744;
}

.sn-desc {
  margin: 0;
  font-size: 16px;
  line-height: 1.7;
  color: #7f9994;
}

.side-cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 50px;
  border: 1px solid #b7ddd8;
  border-radius: 14px;
  background: #fff;
  color: #009798;
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.side-cta:hover {
  background: #eaf6f4;
  border-color: #009798;
}

.side-cta-arrow {
  font-weight: 700;
}

/* ========== 右侧内容 ========== */
.main-col {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* 列表面板 */
.panel-card {
  background: #fff;
  border: 1px solid #e9efec;
  border-radius: 22px;
  padding: 28px 30px 26px;
  box-shadow: 0 10px 30px rgba(23, 61, 59, 0.06);
}

.panel-eyebrow {
  margin: 0 0 10px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 2px;
  color: #a9bcb6;
}

.panel-head {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding-bottom: 18px;
  margin-bottom: 20px;
  border-bottom: 1px solid #eef2f0;
}

.panel-title {
  margin: 0;
  font-size: 30px;
  font-weight: 700;
  color: #304744;
}

.panel-note {
  margin-left: auto;
  font-size: 16px;
  color: #9aa8a3;
}

/* 筛选行 */
.filter-row {
  display: flex;
  align-items: flex-end;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 18px;
}

.filter-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.filter-grow {
  flex: 1;
  min-width: 220px;
}

.filter-label {
  font-size: 16px;
  color: #7f9994;
}

.btn-search,
.btn-reset {
  height: 40px;
  padding: 0 26px;
  border-radius: 10px;
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-search {
  border: 1px solid #009798;
  background: #009798;
  color: #fff;
}

.btn-search:hover {
  background: #007e7f;
  border-color: #007e7f;
}

.btn-reset {
  border: 1px solid #d3e6e3;
  background: #fff;
  color: #527f77;
}

.btn-reset:hover {
  border-color: #009798;
  color: #009798;
}

/* 状态筛选 pills */
.status-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 20px;
}

.pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 38px;
  padding: 0 20px;
  border: 1px solid #e2eae7;
  border-radius: 999px;
  background: #fff;
  color: #527f77;
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.pill:hover {
  border-color: #b7ddd8;
  color: #009798;
}

.pill.active {
  border-color: #009798;
  background: #009798;
  color: #fff;
}

.pill em {
  font-style: normal;
  font-size: 16px;
  font-weight: 700;
  color: #009798;
}

.pill.active em {
  color: #fff;
}

/* 订单卡片 */
.order-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.order-item {
  border: 1px solid #e9efec;
  border-radius: 16px;
  background: #fbfdfc;
  padding: 14px 20px 16px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.order-item:hover {
  border-color: #b7ddd8;
  background: #fff;
  box-shadow: 0 10px 24px rgba(23, 61, 59, 0.07);
}

.oi-head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 12px;
  margin-bottom: 14px;
  border-bottom: 1px dashed #e6efec;
}

.oi-no {
  font-size: 16px;
  color: #7f9994;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.oi-no-label {
  color: #a9bcb6;
}

.oi-status {
  margin-left: auto;
  flex-shrink: 0;
  padding: 5px 14px;
  border-radius: 999px;
  background: #e6f4f1;
  color: #009798;
  font-size: 16px;
  font-weight: 600;
}

.oi-body {
  display: flex;
  align-items: center;
  gap: 16px;
}

.oi-avatar {
  flex-shrink: 0;
  width: 46px;
  height: 46px;
  border-radius: 12px;
  background: #d9efeb;
  color: #009798;
  font-size: 20px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.oi-main {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 160px;
}

.oi-name {
  font-size: 18px;
  font-weight: 700;
  color: #304744;
}

.oi-sub {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  font-size: 16px;
  color: #9aa8a3;
}

.oi-type {
  color: #527f77;
}

.oi-meta {
  display: flex;
  align-items: flex-start;
  margin-left: auto;
  min-width: 210px;
}

.oi-meta-cell {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.oi-meta-label {
  font-size: 16px;
  color: #a9bcb6;
}

.oi-meta-value {
  font-size: 17px;
  font-weight: 600;
  color: #304744;
}

.oi-detail {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  font-weight: 600;
  color: #009798;
  white-space: nowrap;
}

.oi-detail em {
  font-style: normal;
  transition: transform 0.2s ease;
}

.order-item:hover .oi-detail em {
  transform: translateX(4px);
}

/* 空状态 */
.order-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 240px;
  border: 1px dashed #dcebe7;
  border-radius: 16px;
  background: #fbfdfc;
}

.order-empty p {
  margin: 0;
  font-size: 17px;
  color: #9aa8a3;
}

/* 分页 */
.order-pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 22px;
  padding-top: 18px;
  border-top: 1px solid #eef2f0;
}

.pager-total {
  font-size: 16px;
  color: #7f9994;
}

.pagination {
  margin: 0;
}

/* ========== 二维码弹窗 ========== */
.dialog-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qrcode-dialog-text {
  color: #304744;
  font-size: 16px;
  margin-top: 20px;
}

.qrcode-dialog-text>b {
  color: #009798;
  font-size: 16px;
  cursor: pointer;
}

/* ========== Element 组件配色 ========== */
.filter-month>>>.el-input__inner,
.filter-input>>>.el-input__inner {
  height: 40px;
  border-radius: 10px;
  border-color: #d3e6e3;
  color: #304744;
  font-size: 16px;
}

.filter-month>>>.el-input__inner:focus,
.filter-input>>>.el-input__inner:focus {
  border-color: #009798;
}

.filter-month>>>.el-input__icon {
  line-height: 40px;
}

.filter-month>>>.el-input__prefix {
  display: none;
}

.pagination>>>.el-pager li.active {
  background-color: #009798 !important;
  color: #fff !important;
}

.pagination>>>.el-pager li:hover {
  color: #009798;
}

.pagination>>>.btn-prev,
.pagination>>>.btn-next {
  background-color: #f1f7f5;
}

/* ========== 响应式 ========== */
@media (max-width: 1024px) {
  .layout {
    grid-template-columns: 1fr;
  }

  .side-col {
    position: static;
  }

  .oi-meta {
    min-width: 190px;
  }
}

@media (max-width: 768px) {
  .page-container {
    padding: 20px 16px 32px;
  }

  .hero-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .hero-title {
    font-size: 28px;
  }

  .panel-card {
    padding: 20px 16px 20px;
    border-radius: 18px;
  }

  .panel-title {
    font-size: 22px;
  }

  .filter-row {
    flex-direction: column;
    align-items: stretch;
  }

  .btn-search,
  .btn-reset {
    width: 100%;
  }

  .oi-body {
    flex-wrap: wrap;
  }

  .oi-meta {
    width: 100%;
    min-width: 0;
    margin-left: 0;
  }

  .oi-detail {
    margin-left: auto;
  }
}
</style>
